// src/components/dashboard/masteradmin/CompanyComparisonChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import DashboardCard from '../DashboardCard';

function CompanyComparisonChart({ data, loading, onSelectCompany }) {
  return (
    <DashboardCard
      title="Company Comparison — Participants (last 12 months)"
      icon="bi-building"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No company data yet."
    >
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="companyName" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar
              dataKey="participants"
              fill="#6610f2"
              name="Participants"
              cursor="pointer"
              onClick={(entry) => onSelectCompany({ id: entry.companyId, name: entry.companyName })}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="text-muted small mt-2">Click a bar to drill into that company.</div>
    </DashboardCard>
  );
}

export default CompanyComparisonChart;
